export const monthlyReleaseVideos = {
    "July 2023": {
        videoURL: "https://www.youtube.com/watch?v=jacIhZP3fy0",
        video: 7,
        thumbnailURL: "https://i.imgur.com/6QZ1nqE.jpg"
    },
    "August 2023": {
        videoURL: "https://youtu.be/ycQ9qgh1tTU?si=NMpViWsm6pb1kyWm",
        video: 8,
        thumbnailURL: "https://i.imgur.com/6QZ1nqE.jpg"
    },
    "April 2025": {
        videoURL: "https://youtu.be/IZq7KrkLoHU?si=T6Yz1wuEBuoiEcbU",
        video: 4,
        thumbnailURL: "https://i.imgur.com/6QZ1nqE.jpg"
    }
}
